<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input
              v-model="keyword"
              placeholder="Firma Adı, Kullanıcı Adı..."
              @keydown.enter="searchData"
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                @click="searchData"
              >
                <FeatherIcon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="auto"
        >
          <b-button
            variant="primary"
            :to="$route.path + '/customer-search'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(fullname)="data">
        <div>{{ data.item.fullname }}</div>
        <div class="text-primary font-small-2">
          {{ data.item.company }}
        </div>
      </template>
      <template #cell(logined)="data">
        <div :class="data.item.status === '1'? 'text-success' : 'text-danger'">
          <FeatherIcon
            :icon="data.item.status === '1'? 'CheckCircleIcon' : 'XCircleIcon'"
          />
          {{ data.item.status === '1'? 'Hesap Aktif' : 'Hesap Kapalı' }}
        </div>
        <div class="text-muted font-small-2">
          {{ data.item.logined? moment(data.item.logined).format('llll') : 'Henüz giriş yapılmamış' }}
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            :edit-action="$route.path + '/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="data.item.id"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'customer_accounts'
export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ListButtons,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      keyword: '',
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'fullname',
          label: 'ADI SOYADI',
        },
        {
          key: 'email',
          label: 'E-POSTA',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'logined',
          label: 'DURUM',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-50 text-nowrap',
          tdClass: 'width-50 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.fullname AS fullname`,
          `${tableName}.email AS email`,
          `${tableName}.logined AS logined`,
          `${tableName}.status AS status`,
          'customers.company AS company',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['customerAccounts/dataList']
    },
    dataCounts() {
      return this.$store.getters['customerAccounts/dataCounts']
    },
    saveData() {
      return this.$store.getters['customerAccounts/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      if (this.keyword) {
        this.dataQuery.or_like = {
          'customer_accounts.fullname': this.keyword,
          'customers.company': this.keyword,
        }
      } else {
        this.dataQuery.or_like = {}
      }
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('customerAccounts/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('customerAccounts/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
